<template>
  <div class="bg-blackly py-20 text-white">
    <div class="flex w-full container">
      <h2 v-if="heading" class="pr-4 fluid-3xl leading-tightest">{{ heading }}</h2>
      <CtaArrow v-bind="cta[0]" class="cta-arrow ml-auto self-end" />
    </div>
    <CardSlider v-if="stories && stories.length" :items="stories">
      <StoryPreview
        v-for="(story, index) in stories"
        :key="index"
        :story="story"
        class="flex flex-col"
        data-test-id="story"
      />
    </CardSlider>
  </div>
</template>
<script>
import StoryPreview from '@/components/stories/StoryPreview';
import CardSlider from '@/components/common/CardSlider';
import CtaArrow from '@/components/common/CtaArrow';

export default defineNuxtComponent({
  name: 'StoryTeaserBlack',
  components: {
    CtaArrow,
    StoryPreview,
    CardSlider,
  },
  props: {
    heading: {
      type: String,
      default: null,
    },
    stories: {
      type: Array,
      default: () => [],
    },
    cta: {
      type: Array,
      default: () => [],
    },
  },
});
</script>
